import { NgModule } from "@angular/core";
import { AlertDialogComponent } from "./alert-dialog/alert-dialog.component";
import { AppSelectComponent } from "./app-select/app-select.component";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { DragScrollDirective } from "./directives/dragScroll.directive";
import { FileDragDropDirective } from "./directives/fileDragDrop.directive";
import { MouseScrollDirective } from "./directives/mouseScroll.directive";
import { PhoneMaskDirective } from "./directives/phoneMask.directive";
import { PINMaskDirective } from "./directives/pinMask.directive";
import { YearSelectorDirective } from "./directives/yearSelector.directive";
import { EventDialogComponent } from "./event-dialog/event-dialog.component";
import { interceptorProviders } from "./interceptors/interceptors";
import { LoadingOverlayLinearComponent } from "./loading-overlay-linear/loading-overlay-linear.component";
import { MultiCheckGridFilterComponent } from "./multi-check-grid-filter/multi-check-grid-filter.component";
import { NavigationComponent } from "./navigation/navigation.component";
import { NotificationComponent } from "./notification/notification.component";
import { BaseUrlPipe } from "./pipes/baseUrl.filter";
import { BoolToYesNoPipe } from "./pipes/boolToYesNo.filter";
import { CallbackPipe } from "./pipes/callback.pipe";
import { ContactTypePipe } from "./pipes/contactType.filter";
import { CustomerContactTypeDescriptionPipe } from "./pipes/customerContactTypeDescription.filter";
import { HighlightPipe } from "./pipes/highlight.pipe";
import { JerueDatePipe } from "./pipes/jerueDate.filter";
import { LocalDateTimePipe } from "./pipes/localDateTime.filter";
import { OrderByPipe } from "./pipes/orderBy.pipe";
import { PercentagePipe } from "./pipes/percentage.filter";
import { ProperNamePipe } from "./pipes/properName.filter";
import { SafePipe } from "./pipes/safe.pipe";
import { ShortTimePipe } from "./pipes/shortTime.filter";
import { TypeDescriptionPipe } from "./pipes/typeDescription.filter";
import { ProgressDonutComponent } from "./progress-donut/progress-donut.component";
import { PromptDialogComponent } from "./prompt-dialog/prompt-dialog.component";
import BaseDataService from "./services/baseData.service";
import { ConfettiService } from "./services/confetti.service";
import ElementScrollService from "./services/elementScroll.service";
import NotificationService from "./services/notification.service";
import WindowService from "./services/window.service";
import { UniversalSearchComponent } from "./universal-search/universal-search.component";
import { ValidationSummaryComponent } from "./validation-summary/validation-summary.component";
import { TimeInputComponent } from "./time-input/time-input.component";
import { NumericFieldDirective } from "./directives/numericField.directive";
import { LostFocusDirective } from "./directives/lostFocus.directive";
import { JeruePhoneInputComponent } from "./jerue-phone-input/jerue-phone-input.component";
import { EnumDisplayPipe } from "./pipes/enum-display.pipe";
import { SortColumnChooserDirective } from "./directives/sortColumnChooser.directive";
import { StickyShadowDirective } from "./directives/stickyShadow.directive";
import { ArcusBreadcrumbComponent } from "./arcus-breadcrumb/arcus-breadcrumb.component";
import { ArcusToolbarComponent } from "./arcus-toolbar/arcus-toolbar.component";
import { AnonymousToolbarComponent } from "./anonymous-toolbar/anonymous-toolbar.component";
import { TimezoneOffsetPipe } from "./pipes/timezone-offset.pipe";
import { HighlightDirective } from "./directives/highlight.directive";
import { HideForRolesDirective } from "./directives/hideForRoles.directive";

export class RegEx {
    escapeString: RegExp;
    email: RegExp;
    phone: RegExp;
    ssn: RegExp;
    ein: RegExp;
    decimal: RegExp;
}

export class KeyCode {
    enter: number;
    cancel: number;
}

@NgModule({
    imports: [
        AppSelectComponent,
        LoadingOverlayLinearComponent,
        ProgressDonutComponent,
        ValidationSummaryComponent,
        AlertDialogComponent,
        ConfirmDialogComponent,
        EventDialogComponent,
        PromptDialogComponent,
        BaseUrlPipe,
        BoolToYesNoPipe,
        CallbackPipe,
        ContactTypePipe,
        CustomerContactTypeDescriptionPipe,
        EnumDisplayPipe,
        JerueDatePipe,
        LocalDateTimePipe,
        OrderByPipe,
        PercentagePipe,
        ProperNamePipe,
        SafePipe,
        ShortTimePipe,
        TypeDescriptionPipe,
        HighlightPipe,
        MultiCheckGridFilterComponent,
        PhoneMaskDirective,
        PINMaskDirective,
        FileDragDropDirective,
        LostFocusDirective,
        MouseScrollDirective,
        DragScrollDirective,
        StickyShadowDirective,
        SortColumnChooserDirective,
        YearSelectorDirective,
        NumericFieldDirective,
        NotificationComponent,
        UniversalSearchComponent,
        NavigationComponent,
        TimeInputComponent,
        JeruePhoneInputComponent,
        ArcusBreadcrumbComponent,
        ArcusToolbarComponent,
        AnonymousToolbarComponent,
        TimezoneOffsetPipe,
        HighlightDirective,
        HideForRolesDirective,
    ],
    providers: [
        interceptorProviders,
        BaseDataService,
        ElementScrollService,
        NotificationService,
        WindowService,
        ConfettiService,
    ],
    exports: [
        AppSelectComponent,
        LoadingOverlayLinearComponent,
        ProgressDonutComponent,
        ValidationSummaryComponent,
        AlertDialogComponent,
        ConfirmDialogComponent,
        EventDialogComponent,
        PromptDialogComponent,
        BaseUrlPipe,
        BoolToYesNoPipe,
        CallbackPipe,
        ContactTypePipe,
        CustomerContactTypeDescriptionPipe,
        EnumDisplayPipe,
        JerueDatePipe,
        LocalDateTimePipe,
        OrderByPipe,
        PercentagePipe,
        ProperNamePipe,
        SafePipe,
        ShortTimePipe,
        TypeDescriptionPipe,
        HighlightPipe,
        MultiCheckGridFilterComponent,
        PhoneMaskDirective,
        PINMaskDirective,
        FileDragDropDirective,
        LostFocusDirective,
        MouseScrollDirective,
        DragScrollDirective,
        StickyShadowDirective,
        SortColumnChooserDirective,
        YearSelectorDirective,
        NumericFieldDirective,
        NotificationComponent,
        UniversalSearchComponent,
        NavigationComponent,
        TimeInputComponent,
        JeruePhoneInputComponent,
        ArcusBreadcrumbComponent,
        ArcusToolbarComponent,
        AnonymousToolbarComponent,
        TimezoneOffsetPipe,
        HighlightDirective,
        HideForRolesDirective,
    ],
})
export class ArcusCommonModule {}
